import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input'

import "./style.scss";
import { ConsentCheck } from "../ConsentCheck";

import { useDispatch, useSelector } from "react-redux";
import { GlobalState, UserState } from "src/store/types";
import { updateUserDataStateAction, setUserAuthorizedStateAction } from "../../../../../../../../store/actions";
import socket from '../../../../../../../../socket/socket';
import { ForwardRefExoticComponent, JSXElementConstructor, ReactElement, ReactNode, RefAttributes, useEffect } from 'react';
import { Spinner } from '../Spinner';

const svgRU = require('../../../../../../../../scss/icons/RU.svg') as string;
const svgBY = require('../../../../../../../../scss/icons/BY.svg') as string;
interface Props {
  children: ReactNode
  sendMessage: (event: any) => void
}

const getIsCorrectUserData = (userData: UserState['userData']) => {
  if (isValidPhoneNumber(userData.phone) && userData.isDataProcessingConsentGiven && userData.userName) {
    return true
  }

  return false
}

export const SenderPanel = ({ children, sendMessage }: Props) => {
  const { isConnectionAwaiting, userName, phone, isDataProcessingConsentGiven, isCorrectUserData, client_id, room_id } = useSelector((state: GlobalState) => ({
    ...state.user.userData,
    isCorrectUserData: state.user.isUserAuthorized || getIsCorrectUserData(state.user.userData),
    client_id: state.rooms.client_id,
    room_id: state.rooms.room_id,
    isConnectionAwaiting: state.behavior.isConnectionAwaiting,
  }));
  const dispatch = useDispatch();
  const isUserAuthorized = useSelector((state: GlobalState) => (state.user.isUserAuthorized));

  useEffect(() => {
    if (!socket.status && !socket.awaitConnection) {
      socket.connect('', '');
    }
  }, [client_id, room_id])

  if (!socket.status || isConnectionAwaiting) {
    return <div className="sender-panel"> <div className='loading'><Spinner />Идет подключение</div></div>
  }

  if (isUserAuthorized) {
    const vkLink = process.env.VK_LINK || 'https://vk.com';
    return (
      <div className="sender-panel">
        {children}
        <a
          href={vkLink}
          target="_blank"
          rel="noopener noreferrer"
          className="sender-panel__vk-link"
          onClick={(e) => {
            e.stopPropagation();
            window.open(vkLink, '_blank', 'noopener,noreferrer');
          }}
        >
          MAX
        </a>
      </div>
    );
  }

  const handelChangeUserData = (fiendName: string, value: unknown) => {
    dispatch(updateUserDataStateAction({ [fiendName]: value }));
  }
  const handelUserAuthorization = () => {
    socket.authorization({ userName, phone, isDataProcessingConsentGiven })
    dispatch(setUserAuthorizedStateAction(true));
    sendMessage('Вы нажали начать новый диалог')
  }

  return (
    <div className="sender-panel">
      <div className="sender-panel__item">
        <span> Представьтесь пожалуйста <b>*</b></span>
        <input value={userName} onChange={(event) => handelChangeUserData('userName', event.target.value)} />
      </div>

      <div className="sender-panel__item">
        <span>Укажите Ваш номер <b>*</b></span>
        {/* @ts-ignore */}
        <PhoneInput
          addInternationalOption={false}
          defaultCountry="RU"
          countries={['RU', 'BY']}
          labels={{ 'RU': 'Россия', 'BY': 'Беларусь' }}
          flags={{ 'RU': () => <img src={svgRU} />, 'BY': () => <img src={svgBY} /> }}
          value={phone}
          className={!phone || isValidPhoneNumber(phone) ? '' : 'error'}
          onChange={(phone) => handelChangeUserData('phone', phone || '')} />
      </div>
      <ConsentCheck checked={isDataProcessingConsentGiven} onChange={(value) => handelChangeUserData('isDataProcessingConsentGiven', value)} />
      <button className={`sender-panel__button rcw-menu`}
        style={{
          width: '100%'
        }}
        onClick={handelUserAuthorization}
        disabled={!isCorrectUserData}
      >
        Начать новый диалог
      </button>
    </div>
  );
};
